import { Moment } from 'moment';
import { TrendData } from '../../../common/dashboards/models/TrendData';

export class OrganizationSummary {
  constructor(private readonly name: string, private readonly createdAt: Moment | null, private readonly trendData: TrendData[]) {}

  getName() {
    return this.name;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getTrendData() {
    return this.trendData;
  }

  static getBlank() {
    return new OrganizationSummary('', null, []);
  }
}
